<template>
    <div class="flex xs12 sm12 md12 lg12 xl9">
        <div class="l-side flex xs12 sm12 md12 lg5 xl5">
            <div class="form-l" v-if="isShowForm">
                <div class="form-l__inner">
                    <div class="form-l__title">
                        <h4 class="title-h4">
                            {{ $t("members.password-confirm.title") }}
                        </h4>
                    </div>
                    <div class="form-l__content">
                        <p>
                            {{ $t("members.password-confirm.sub") }}
                        </p>
                    </div>
                    <div class="form-l__body">
                        <form class="form" @submit.prevent="submitHandler">
                            <div class="form__row">
                                <div class="form__row-title ">
                                    {{ $t("form.new_password") }}
                                </div>
                                <div class="form__row-field">
                                    <textField
                                            v-model.trim="confirm.password"
                                            :v="$v.confirm.password"
                                            :placeholder="$t('form.new_password')"
                                            type="password"
                                            theme="light"
                                    />
                                </div>
                            </div>
                            <div class="form__row">
                                <div class="form__row-title ">
                                    {{ $t("form.repeat_new_password") }}
                                </div>
                                <div class="form__row-field">
                                    <textField
                                            v-model.trim="confirm.password_confirmation"
                                            :v="$v.confirm.password_confirmation"
                                            :placeholder="$t('form.repeat_new_password')"
                                            type="password"
                                            theme="light"
                                    />
                                </div>
                            </div>
                            <div class="form__action">
                                <button type="submit" class="btn btn-w100 btn-gradient">
                                    <span> {{ $t("form.change_password") }}</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import textField from "@/elements/textField";
    import validate from "@/mixins/validate";
    export default {
        mixins: [validate],
        components: {
            textField
        },
        data() {
            return {
                isShowForm: false,
                confirm: {
                    code: '',
                    password: '',
                    password_confirmation: ''
                }
            }
        },
        methods: {
            async submitHandler() {
                this.$v.confirm.$touch();
                if (!this.$v.confirm.$invalid) {
                    let response = await this.$store.dispatch('CLIENT_RESET_PASSWORD_CONFIRM', this.confirm)
                    if(response && response.status === 200) {
                        this.$router.push('/members/confirm-reset-password-success')
                    }
                }
            },
            async checkResetPasswordCode(code) {
                let response = await this.$store.dispatch('CLIENT_CHECK_RESET_PASSWORD_CODE', {code: code})
                if(response && response.status === 200) {
                    let {ok} = response.data.data;
                    if(ok) {
                        this.confirm.code = code;
                        this.isShowForm = true;
                    } else {
                        this.goToLogin()
                    }
                } else {
                    this.goToLogin()
                }
            },
            goToLogin() {
                this.$router.push('/members/sign-in')
            }
        },
        created() {
            let query = this.$route.query;
            if(Object.keys(query).length && query.code) {
                this.checkResetPasswordCode(query.code)
            } else {
                this.goToLogin()
            }
        },
        beforeDestroy() {
            this.isShowForm = false;
        }
    }
</script>

<style lang="sass" scoped>

</style>